import { render, staticRenderFns } from "./batchProcessing.vue?vue&type=template&id=dc4242a8&scoped=true&"
import script from "./batchProcessing.vue?vue&type=script&lang=js&"
export * from "./batchProcessing.vue?vue&type=script&lang=js&"
import style0 from "./batchProcessing.vue?vue&type=style&index=0&id=dc4242a8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4242a8",
  null
  
)

export default component.exports